'use client';

import { useRouter } from 'next/router';

import { useCallback } from 'react';

import { Button, Flex, Text } from '@chakra-ui/react';

import { urlJoinP } from 'url-join-ts';

import { IconsLinear } from '@nocowanie/icons';

import { environment } from '@app/environments/environment';

interface PreviewBannerProps {
    isPreview: boolean;
}

export const PreviewBanner = ({ isPreview }: PreviewBannerProps) => {
    const router = useRouter();
    const handleRedirect = useCallback(() => {
        router.replace(urlJoinP(environment.SSR_API_HOST, ['exit-preview', '/']));
    }, []);

    if (!isPreview) {
        return null;
    }

    return (
        <Flex
            align={'center'}
            justify={'center'}
            gap={4}
            bg={'orange.600'}
            color={'white'}
            py={2}
            px={3}
            position={'fixed'}
            width={'100vw'}
            bottom={0}
            zIndex={'max'}
            boxShadow={'md'}
        >
            <Flex align={'center'} justify={'center'} gap={2}>
                <IconsLinear.InfoCircle fontSize={'xl'} />
                <Text fontWeight={'bold'} fontSize={{ base: 'sm', md: 'md' }}>
                    Preview mode
                </Text>
            </Flex>
            <Button
                onClick={handleRedirect}
                size={'sm'}
                fontSize={{ base: 'sm', md: 'md' }}
                py={1}
                px={4}
                bg={'white'}
            >
                Zamknij
            </Button>
        </Flex>
    );
};
